module.exports = __webpack_public_path__ + "static/media/cat-all.af04c0a7.svg";